import * as React from 'react';
import { connect } from 'react-redux';

import { SelectedPosts as SelectedPostsComponent } from '../../components/selected_posts/selected_posts';
import { ISelectedPosts } from '../../types/selected_posts';
import { IMenuRubricsState, IRubric } from '../../reducers/modules/rubrics_menu/rubrics_menu';
import { getMenuRubricsData, selectRubric } from '../../../app/utils';

interface IProps {
  selectedPosts: ISelectedPosts;
  menuItems: IRubric[];
}

const SelectedPostsContainer: React.FC<IProps> = props => {
    const {
      selectedPosts: { items: selectedPostsItems },
      menuItems,
    } = props;

    return (selectedPostsItems && selectedPostsItems.length > 0) ?
            <SelectedPostsComponent items={selectedPostsItems} menuItems={menuItems} /> :
            <div/>;
}

export const SelectedPosts = connect(
  (state: {
    selectedPosts: ISelectedPosts,
    menuRubrics: IMenuRubricsState,
  }) => ({
    selectedPosts: state.selectedPosts,
    menuItems: getMenuRubricsData(state.menuRubrics.items)(selectRubric),
  }),
)(SelectedPostsContainer);
